export default __webpack_public_path__ + "static/media/helo1.826f6ead.jpg";